<template>
  <!-- 业务联系人 -->
  <div class="Business-contacts">
    <div class="Business-content">
      <div class="Business-top">
        <h1>业务联系人信息</h1>
        <!-- <svg-icon class="icon" iconClass="add" :systemColor="false"></svg-icon> -->
      </div>
      <div class="Business-top-one Content-flex line">
        <el-input v-model="contactName" placeholder="点击输入联系人姓名"></el-input>
        <el-button style="height: 28px;line-height: 5px;" round @click="numberTypeShow = true">添加联系方式</el-button>
      </div>

      <div v-for="(numberItem,numberIndex) in numberList" :key="numberIndex" :class="numberList.length > numberIndex+1 ? 'Business-top-for Content-flex line' : 'Business-top-for Content-flex No-line'">
        <div class="Content-left">
          <svg-icon class="icon" :iconClass="numberItem.icon"></svg-icon>
          <el-input style="width: 200px;padding-left: 15px;" v-model="numberItem.number" :placeholder="numberItem.name"></el-input>
        </div>
        <div class="Content-right" v-if="numberList.length > 3">
          <svg-icon class="icon" iconClass="delete" @click="delNumberType(numberIndex)"></svg-icon>
        </div>
      </div>
    </div>

    <el-dialog class="productTypeDialog" title="提示" custom-class="customProduct" :visible.sync="numberTypeShow" width="40%">
      <div class="dialog-top">
        <span>选择要添加的联系方式</span>
      </div>
      <div class="product-checkBox">
        <el-checkbox-group v-model="numberCheckArr">
          <el-checkbox :label="1">手机号</el-checkbox>
          <el-checkbox :label="2">微信号</el-checkbox>
          <el-checkbox :label="0">邮箱</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="numberTypeShow = false">取 消</el-button>
        <el-button type="primary" @click="sureNumberType">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import { mapState } from 'vuex'
  export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
      return {
        numberCheckArr: [],
        numberTypeShow: false,
        contactName: '',
        numberList: [
        {
          contactName: '',
          numberType: 0,
          name: '点击输入邮箱',
          number: '',
          icon: 'email'
        },
        {
          contactName: '',
          numberType: 1,
          name: '点击输入手机号',
          number: '',
          icon: 'phone'
        },
        {
          contactName: '',
          numberType: 2,
          name: '点击输入微信号',
          number: '',
          icon: 'weixin'
        }]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapState(['supplierBasics'])
    },
    // 监控data中的数据变化
    watch: {
      numberList: {
        handler(value) {
          value.forEach(item => item.contactName = this.contactName)
          this.$store.commit('setNumberList', value)
        },
        deep: true
      },
      'supplierBasics': {
        handler(value) {
          console.log('sjidsfsdf', value)
          value.numberList.forEach(y => {
            let find = this.numberList.find(x => x.numberType == y.numberType)
            if (find) {
              y.icon = find.icon
            }
          })
          if (value.numberList.length > 0) {
            this.contactName = value.numberList[0].contactName
            this.numberList = value.numberList
          }
        },
        deep: true
      }
    },
    // 方法集合
    methods: {
      sureNumberType() {
        this.numberCheckArr.forEach(item => {
          this.numberList.push({
            numberType: item,
            name: item == 0 ? '点击输入邮箱' : item == 1 ? '点击输入手机号' : '点击输入微信号',
            number: '',
            icon: item == 0 ? 'email' : item == 1 ? 'phone' : 'weixin'
          })
        })
        this.numberTypeShow = false
      },
      delNumberType(index) {
        this.numberList.splice(index, 1)
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  .Business-contacts {
    //width: 12.8rem;
    margin: 0 auto;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
    border-radius: 6px 6px 6px 6px;
    background-color: rgba(255, 255, 255, 1);
    margin: 15px auto;

    .Business-content {
      padding: 30px;
    }

    .Business-top {
      display: flex;

      .Business-top-one {}
    }
  }

  .Content-flex {
    display: flex;
    padding-top: 12px;

    .icon {
      margin-top: 4px;
    }
  }

  .Business-content /deep/.el-input__inner {
    border: none;
    background: none;
    border-radius: 0 !important;
    padding-left: 0;
    font-size: 14px;
    font-family: PingFangSC-light;
  }

  .line {
    border-bottom: 1.3px dashed rgba(242, 237, 237, 1);
  }

  .No-line {
    border-bottom: none;
  }

  .Content-left {
    display: flex;
  }

  .Content-right {
    display: flex;
    align-items: center;
  }

  .Business-top-for {
    justify-content: space-between;
  }

  .productTypeDialog /deep/.el-dialog__header {
    display: none;
  }

  .productTypeDialog /deep/.dialog-top {
    width: 100%;
    background: var(--color);
    color: white;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-radius: 0.2rem 0.2rem 0 0;
    font-size: 14px;
  }

  .productTypeDialog /deep/.el-dialog__body {
    padding: 0;
  }

  .productTypeDialog /deep/.el-checkbox {
    width: 0.7rem;
    line-height: 2;
  }

  .productTypeDialog /deep/.product-checkBox {
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>